"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Table = _interopRequireDefault(require("../../preact-components/table/Table"));

var _UserCell = _interopRequireDefault(require("../overview/cells/UserCell"));

var _Loader = require("./Loader");

var _EmptyTable = _interopRequireDefault(require("./EmptyTable"));

var _EmptyResults = require("./EmptyResults");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopUsersTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopUsersTable, _Component);

  var _super = _createSuper(TopUsersTable);

  function TopUsersTable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TopUsersTable);
    _this = _super.call(this, props);

    _this.setState({
      topUsers: [],
      sorting: {
        order: 'posts',
        direction: 'desc'
      },
      isLoading: true
    });

    return _this;
  }

  (0, _createClass2.default)(TopUsersTable, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedRanks !== prevProps.selectedRanks)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchTopUsers();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchTopUsers",
    value: function () {
      var _fetchTopUsers = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context2.prev = 1;
                _context2.next = 4;
                return this.props.fetchData('/analyticsV2/fetchTopUsers');

              case 4:
                res = _context2.sent;
                this.setState({
                  topUsers: res.data,
                  isLoading: false
                });

              case 6:
                _context2.prev = 6;
                this.setState({
                  isLoading: false
                });
                return _context2.finish(6);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 6, 9]]);
      }));

      function fetchTopUsers() {
        return _fetchTopUsers.apply(this, arguments);
      }

      return fetchTopUsers;
    }()
  }, {
    key: "getModel",
    value: function getModel() {
      return [{
        header: 'Username',
        accessor: 'user',
        cell: (0, _UserCell.default)('user'),
        size: 'm'
      }, {
        header: 'Posts',
        accessor: 'posts',
        size: 'xs-right',
        sorting: 'posts'
      }, {
        header: 'Topics',
        accessor: 'topics',
        size: 'xs-right',
        sorting: 'topics'
      }, {
        header: 'Replies',
        accessor: 'replyCount',
        size: 'xs-right',
        sorting: 'replyCount'
      }, {
        header: 'Likes received',
        accessor: 'likesReceived',
        size: 'xs-right',
        sorting: 'likesReceived'
      }, {
        header: 'Likes given',
        accessor: 'likesGiven',
        size: 'xs-right',
        sorting: 'likesGiven'
      }, {
        header: 'Answers given',
        accessor: 'answersGiven',
        size: 'xs-right',
        sorting: 'answersGiven'
      }, {
        header: 'Points earned',
        accessor: 'points',
        size: 'xs-right',
        sorting: 'points'
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          topUsers = _this$state.topUsers,
          sorting = _this$state.sorting,
          isLoading = _this$state.isLoading;
      var tooltip = (0, _preact.h)(_Tooltip.default, {
        position: "center",
        trigger: (0, _preact.h)(_assets.default, {
          icon: "question",
          size: 16,
          customClass: "icon-info"
        }),
        customClasses: "graph-help-tooltip",
        tooltipMessage: (0, _preact.h)("div", {
          className: "graph-help-tooltip-text"
        }, (0, _preact.h)("p", null, "Counts for Topics, Replies and Answers also include content from categories that have the \u2018exclude from user statistics\u2019 option enabled."), (0, _preact.h)("p", null, "This may show different counts compared to user\u2019s profile page."))
      });
      var table = (0, _preact.h)(_EmptyTable.default, {
        model: this.getModel(),
        actionElements: (0, _preact.h)("div", {
          className: "title-top_users__table"
        }, " Top users", tooltip)
      }, (0, _preact.h)(_Loader.Loader, {
        parentCustomClass: "dashboard-table-loader"
      }));

      if (!isLoading) {
        if (topUsers.length > 0) {
          table = (0, _preact.h)(_Table.default, {
            model: this.getModel(),
            rows: topUsers,
            rowId: "userId",
            classes: ['top_users__table'],
            onSortChange: function onSortChange(attr) {
              var newSorting;

              if (sorting && sorting.order === attr) {
                newSorting = {
                  order: attr,
                  direction: sorting.direction === 'asc' ? 'desc' : 'asc'
                };
              } else {
                newSorting = {
                  order: attr,
                  direction: 'asc'
                };
              }

              topUsers.sort(function (a, b) {
                if (a[attr] > b[attr]) return 1 * (newSorting.direction === 'asc' ? 1 : -1);
                if (a[attr] < b[attr]) return -1 * (newSorting.direction === 'asc' ? 1 : -1);
                return 0;
              });

              _this2.setState({
                sorting: newSorting
              });
            },
            sort: sorting,
            "data-element-name": "Top users table sort button",
            "data-track-type": "click",
            actionElements: (0, _preact.h)("div", {
              className: "title-top_users__table"
            }, "Top users", tooltip)
          });
        } else {
          table = (0, _preact.h)(_EmptyTable.default, {
            model: this.getModel(),
            actionElements: (0, _preact.h)("div", {
              className: "title-top_users__table"
            }, " Top users", tooltip)
          }, (0, _preact.h)(_EmptyResults.EmptyResults, null));
        }
      }

      return (0, _preact.h)("div", {
        className: "dashboard-table-wrapper"
      }, table);
    }
  }]);
  return TopUsersTable;
}(_preact.Component);

var _default = TopUsersTable;
exports.default = _default;